import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';
import { SkeletonLoader } from '../Highlights/SingleHighlight/SkeletonLoader';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const TitleContainer = styled.div`
  ${tokens.text('subtitle1')};
  margin-bottom: ${tokens.spacer.x3};
`;

const LinkContainer = styled.div`
  display: flex;
`;

const CopyButtonSkeleton = styled(SkeletonLoader)`
  width: 40px;
  height: 40px;
`;

const OutputLinkSkeleton = styled(SkeletonLoader)`
  width: 236px;
  height: 40px;
  margin-right: ${tokens.spacer.x1};
`;

export interface ShortLinkDropdownSkeletonLoaderProps {
  title?: string;
}

export function ShortLinkDropdownSkeletonLoader({
  title,
}: ShortLinkDropdownSkeletonLoaderProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <TitleContainer>{title ?? t('common:actions.share')}</TitleContainer>
      <LinkContainer>
        <OutputLinkSkeleton />
        <CopyButtonSkeleton />
      </LinkContainer>
    </Wrapper>
  );
}
